import React from 'react';
import MDElement from '../MDElement';

const Resources = () => {
 
    const style = {textAlign: "left"}
    return (
        <>

            <MDElement path="Resources/Resources.md" />
        </>
    )
};

export default Resources;